require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/fn/get-iterator.js
// module id = m1eO
// module chunks = 0